
import React from 'react';
import { useBooking } from '../../context/BookingContext';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { CheckCircle } from 'lucide-react';
import { format } from 'date-fns';

const AppointmentConfirmation: React.FC = () => {
  const { state, resetBooking } = useBooking();
  const { doctor, date, timeSlot, patientDetails } = state;

  if (!doctor || !date || !timeSlot) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">Missing appointment information.</p>
        <Button className="mt-4" onClick={resetBooking}>Start New Booking</Button>
      </div>
    );
  }

  const appointmentNumber = `APT-${Math.floor(100000 + Math.random() * 900000)}`;
  
  return (
    <div className="animate-fade-in flex flex-col items-center">
      <div className="text-center mb-6">
        <CheckCircle className="w-16 h-16 text-secondary mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-foreground">Appointment Confirmed!</h2>
        <p className="text-muted-foreground">Your appointment has been successfully scheduled</p>
      </div>

      <Card className="w-full max-w-md">
        <CardHeader className="text-center bg-primary/10 rounded-t-lg">
          <CardTitle>Appointment Details</CardTitle>
        </CardHeader>
        <CardContent className="pt-6 space-y-4">
          <div className="text-center mb-4">
            <p className="text-sm text-muted-foreground">Appointment Number</p>
            <p className="font-mono font-medium text-lg">{appointmentNumber}</p>
          </div>
          
          <div className="space-y-4 divide-y">
            <div className="pb-2">
              <p className="text-sm text-muted-foreground">Doctor</p>
              <p className="font-medium">{doctor.name}</p>
              <p className="text-sm text-medical-700">{doctor.specialty}</p>
            </div>
            
            <div className="py-2">
              <p className="text-sm text-muted-foreground">Date & Time</p>
              <p className="font-medium">{format(date, 'EEEE, MMMM do, yyyy')}</p>
              <p>{timeSlot.time}</p>
            </div>
            
            <div className="py-2">
              <p className="text-sm text-muted-foreground">Patient</p>
              <p className="font-medium">{patientDetails.fullName}</p>
              <p>{patientDetails.email}</p>
              <p>{patientDetails.phone}</p>
            </div>
          </div>
          
          <div className="mt-6 text-center text-sm text-muted-foreground">
            <p>A confirmation email has been sent to {patientDetails.email}</p>
            <p className="mt-2">Please arrive 15 minutes before your appointment.</p>
          </div>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button onClick={resetBooking}>Schedule Another Appointment</Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AppointmentConfirmation;
